import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { ADMIN_BLOB } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Blobs.
 * @returns {Promise} - A promise that resolves with the list of Blobs or rejects with an error.
 * @param props
 */
export const listBlob = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}/Filter`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    Blobs: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Blob.
 * @returns {Promise} - A promise that resolves with the creation of Profile Group or rejects with an error.
 * @param data
 */
export const createBlob = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Blob.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const updateBlob = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}/${data?.Id}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete the Blob.
 * @returns {Promise} - A promise that resolves with the delete of blob or rejects with an error.
 * @param data
 */
export const deleteBlob = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}/${data?.Id}/${data?.TenantId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * download the Blob.
 * @returns {Promise} - A promise that resolves with the download of blob or rejects with an error.
 * @param data
 */
export const downloadBlob = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}/${data?.Id}/Download`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * get Blob.
 * @returns {Promise} - A promise that resolves with the Blob or rejects with an error.
 * @param data
 */
export const getBlob = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_BLOB}/${data?.Id}?BlobId=${data?.BlobId}&InstName=${data?.InstName}&EnvId=${data?.EnvId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
